import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  cardsContainerLarge: {
    marginBottom: hp('2%'),
  },
  cardColumnSmall: {
    flexDirection: 'column',
    marginBottom: 30,
  },
  listContainer: {
    marginBottom: 10,
  },
  buttonRecharge: {
    height: hp('10%'),
    borderRadius: 10,
    marginTop: 20,
    backgroundColor: '#F5F5F5',
    padding: 8,
    marginBottom: 6,
  },
  buttonTitle: {
    color: '#0F6657',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: 17,
    textAlign: 'left',
  },
  buttonRechargeTitleLarge: {
    color: '#001639',
    fontWeight: '500',
    fontSize: 18,
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
  buttonRechargeTitleSmall: {
    color: '#001639',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
  buttonContainerLarge: {
    width: wp('20%'),
    paddingRight: 10,
    paddingLeft: 10,
    alignSelf: 'center',
  },
  buttonContainerSmall: {
    alignSelf: 'center',
    width: wp('35%'),
    paddingRight: 10,
    paddingLeft: 10,
  },
});
